import { FieldErrors, useFormContext } from 'react-hook-form'
import { BefehlFormAuftrag, BefehlFormField } from '../Generic'
import { useTranslation } from 'react-i18next'
import { Input } from '../../form'

export interface Auftrag32_10FormProps {
  befehlKennung: string
  fieldPrefix: string
  readOnly: boolean
  'data-testid': string
  errors?: FieldErrors
  activateEmptyFieldWarnings: boolean
}

export default function Auftrag32_10Form({
  readOnly,
  'data-testid': testId,
  fieldPrefix,
  activateEmptyFieldWarnings = false
}: Readonly<Auftrag32_10FormProps>) {
  const formContext = useFormContext()
  const { control, formState } = formContext
  const { t } = useTranslation('ui-befehle')

  const formErrors = formState.errors

  return (
    <BefehlFormAuftrag
      auftragKennung="32.10"
      fieldName={`${fieldPrefix}.enabled`}
      readOnly={true}
      testId={testId}
    >
      <div
        className="flex flex-wrap w-full items-baseline gap-1"
        data-testid={`${testId}-outer-div`}
      >
        <span data-testid={`${testId}-text`}>{t('auftraege.32_10.label')}</span>
        <div className="flex flex-col">
          <BefehlFormField
            name={'auftrag_32_10.signalUsw'}
            control={control}
            label={t('auftraege.32_10.32_11.input_label')}
            readOnly={readOnly}
            activateEmptyWarning={activateEmptyFieldWarnings}
            data-testid={`${testId}-feld-32-11`}
            render={({ field }) => (
              <Input
                {...field}
                label={t('auftraege.32_10.32_11.input_label')}
                errors={formErrors}
                className="w-full"
                data-testid={`${testId}-feld-32-11-inner`}
              />
            )}
          ></BefehlFormField>

          <div>
            <span data-testid={`${fieldPrefix}-feld-32-11-label`}>
              {t('auftraege.32_10.32_11.label')}
            </span>
          </div>
        </div>
      </div>
    </BefehlFormAuftrag>
  )
}
